import PropTypes from 'prop-types';
import styled from 'styled-components';
import {grey, coral} from './color';


const getColorFromProps = ({sub, isPrimary}) => {
    if (sub) {
        return grey.grey400;
    }

    if (isPrimary) {
        return coral.regular;
    }

    return grey.grey000;
};

const Display = styled.h1`
  white-space: pre-line;
  font-weight: normal;
  margin: 0;
  font-family: 'Roboto Mono', monospace;
  font-size: ${({fontSize}) => fontSize};
  color: ${props => getColorFromProps(props)};
  ${props => props.withMargin ? `
    margin-bottom: 16px;  
  ` : ''};
`;

Display.propTypes = {
    sub: PropTypes.bool,
    isPrimary: PropTypes.bool,
    withMargin: PropTypes.bool
};

export const DisplayLargest = styled(Display)`
  font-size: 96px;
  @media (max-width: 768px) {
    font-size: 60px;
  }
`;

DisplayLargest.displayName = 'DisplayLargest';

export const DisplayLarger = styled(Display)`
  font-size: 60px;
  @media (max-width: 768px) {
    font-size: 48px;
  }
`;

DisplayLarger.displayName = 'DisplayLarger';

export const DisplayLarge = styled(Display)`
  font-size: 48px;
  @media (max-width: 768px) {
    font-size: 34px;
  }  
`;

DisplayLarge.displayName = 'DisplayLarge';

export const DisplayMedium = styled(Display)`
  font-size: 34px;
  @media (max-width: 768px) {
    font-size: 24px;
  }  
`;

DisplayMedium.displayName = 'DisplayMedium';

export const DisplaySmall = styled(Display)`
  font-size: 24px;
  @media (max-width: 768px) {
    font-size: 20px;
  }  
`;

DisplaySmall.displayName = 'DisplaySmall';

export const DisplaySmaller = styled(Display)`
  font-size: 20px;
  @media (max-width: 768px) {
    font-size: 16px;
  }  
`;

DisplaySmaller.displayName = 'DisplaySmaller';

export const DisplaySmallest = styled(Display)`
  font-size: 16px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

DisplaySmallest.displayName = 'DisplaySmallest';
